import modelProcessStore from './modules/modelProcessStore';
import recipeOnDemandStore from './modules/recipeOnDemandStore';

export default {
  modules: {
    modelProcessStore,
    recipeOnDemandStore,
  },
};
